export const cardSettings = {
  items: [
    {
      id: 1,
      cardNo: '1234567812345678',
      vehicleNumber: 'RECIPIENT 32',
      cardName: 'Card bancar',
      availableUntil: '2022-12-31T00:00:00',
      cardIssuer: 'MOL',
      dailyLimitSet: 400,
      weeklyLimitSet: 400,
      monthlyLimitSet: 400,
      dailyLimitAvailable: 500,
      weeklyLimitAvailable: 500,
      monthlyLimitAvailable: 500,
      blockRequest: false
    },
    {
      id: 2,
      cardNo: '1234567812345678',
      vehicleNumber: 'RECIPIENT 32',
      cardName: 'Card bancar',
      availableUntil: '2022-12-31T00:00:00',
      cardIssuer: 'MOL',
      dailyLimitSet: 400,
      weeklyLimitSet: 400,
      monthlyLimitSet: 400,
      dailyLimitAvailable: 500,
      weeklyLimitAvailable: 500,
      monthlyLimitAvailable: 500,
      blockRequest: false
    },
    {
      id: 3,
      cardNo: '1234567812345678',
      vehicleNumber: 'RECIPIENT 32',
      cardName: 'Card bancar',
      availableUntil: '2022-12-31T00:00:00',
      cardIssuer: 'MOL',
      dailyLimitSet: 400,
      weeklyLimitSet: 400,
      monthlyLimitSet: 400,
      dailyLimitAvailable: 500,
      weeklyLimitAvailable: 500,
      monthlyLimitAvailable: 500,
      blockRequest: false
    },
    {
      id: 4,
      cardNo: '1234567812345678',
      vehicleNumber: 'RECIPIENT 32',
      cardName: 'Card bancar',
      availableUntil: '2022-12-31T00:00:00',
      cardIssuer: 'MOL',
      dailyLimitSet: 400,
      weeklyLimitSet: 400,
      monthlyLimitSet: 400,
      dailyLimitAvailable: 500,
      weeklyLimitAvailable: 500,
      monthlyLimitAvailable: 500,
      blockRequest: false
    },
    {
      id: 5,
      cardNo: '1234567812345678',
      vehicleNumber: 'RECIPIENT 32',
      cardName: 'Card bancar',
      availableUntil: '2022-12-31T00:00:00',
      cardIssuer: 'MOL',
      dailyLimitSet: 400,
      weeklyLimitSet: 400,
      monthlyLimitSet: 400,
      dailyLimitAvailable: 500,
      weeklyLimitAvailable: 500,
      monthlyLimitAvailable: 500,
      blockRequest: false
    },
    {
      id: 6,
      cardNo: '1234567812345678',
      vehicleNumber: 'RECIPIENT 32',
      cardName: 'Card bancar',
      availableUntil: '2022-12-31T00:00:00',
      cardIssuer: 'MOL',
      dailyLimitSet: 400,
      weeklyLimitSet: 400,
      monthlyLimitSet: 400,
      dailyLimitAvailable: 500,
      weeklyLimitAvailable: 500,
      monthlyLimitAvailable: 500,
      blockRequest: false
    }
  ],
  total: 6,
  totalPages: 1
};

export const cardSettingsDetails = {
  id: 1,
  cardNo: '1234567812345678',
  vehicleNumber: 'RECIPIENT 32',
  cardName: 'Card bancar',
  availableUntil: '2022-12-31T00:00:00',
  cardIssuer: 'MOL',
  dailyLimitRequested: 40000,
  weeklyLimitRequested: 40000,
  monthlyLimitRequested: 60000,
  dailyTransactionsRequested: 100,
  weeklyTransactionsRequested: 100,
  monthlyTransactionsRequested: 150,
  dailyLimitSet: 400,
  weeklyLimitSet: 400,
  monthlyLimitSet: 400,
  dailyLimitAvailable: 500,
  weeklyLimitAvailable: 500,
  monthlyLimitAvailable: 500,
  blockRequest: false
};
